module.exports = __webpack_public_path__ + "static/media/PHOTON.7811cc45.png";